import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { AddAttachmentDialogComponent } from '../../../shared-components/add-attachment-dialog/add-attachment-dialog.component';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { ErrorList } from '../../../shared-components/controls/error-prompt/error-list.model';
import { GeneralConfirmationComponent } from '../../../shared-components/controls/general-confirmation/general-confirmation.component';
import { Attachment } from '../../../shared-components/models/attachment.model';
import { SharedService } from '../../../shared-components/shared.service';
import { StudentInformationComponent } from '../../../shared-components/student-information/student-information.component';
import { StudentService } from '../../../shared-components/student/student.service';
import { YearService } from '../../../shared-components/year/year.service';
import { AttendanceAdministrationService } from '../attendance-administration.service';
import { AttendanceCheckInOutHowToDialogComponent } from '../modals/attendance-check-in-out-how-to-dialog/attendance-check-in-out-how-to-dialog.component';
import { AttendanceCheckInOutLegendComponent } from '../../../shared-components/attendance-check-in-out-legend/attendance-check-in-out-legend.component';
import { AttendanceCheckInOut } from './attendance-check-in-out.model';
import * as moment from 'moment';
import { AttendanceByStudentComponent } from '../attendance-by-student/attendance-by-student.component';
import { Student } from '../../../shared-components/student/student.model';
import { ViewAttachmentsComponent } from '../../../shared-components/view-attachments/view-attachments.component';
import { CheckInOutViewHistoryDialogComponent } from '../../../shared-components/check-in-out-view-history-dialog/check-in-out-view-history-dialog.component';
import { StudentSearchComponent } from '../../../shared-components/student-search/student-search.component';
import { School } from '../../../shared-components/year/school.model';
import { CheckInOutModalDialogComponent } from '../modals/check-in-out-modal-dialog/check-in-out-modal-dialog.component';

@Component({
  selector: 'app-attendance-check-in-out',
  templateUrl: './attendance-check-in-out.component.html',
  styleUrls: ['./attendance-check-in-out.component.css']
})
export class AttendanceCheckInOutComponent implements OnInit, AfterViewInit {
  todaysDate = new Date();
  attendanceDate: Date;
  previousDate: Date;
  includeCompleted = true;
  includeSubmitted = false;
  attendanceCheckInOut: AttendanceCheckInOut[] = [];

  sameDate = true;

  errors: ErrorList[] = [];

  columnsToDisplay = ['Type', 'Time', 'Status', 'StudentNumber', 'Name', 'Period', 'LEMinutes', 'Attachment', 'Actions'];
  angularMatData = new TylerMatTableDataSource(this.attendanceCheckInOut);

  _sort: MatSort;

  datAttendanceDate: ElementRef;

  StudentInfoDialog: MatDialogRef<StudentInformationComponent>;
  subscription: Subscription[] = [];

  selectedStudent: Student;
  schools: School[];

  constructor(
    private attendanceAdminService: AttendanceAdministrationService,
    private studentService: StudentService,
    private dialog: MatDialog,
    private sharedService: SharedService,
    private yearService: YearService
  ) {
    this.subscription.push(
      this.yearService.observableDefaultYearStream$.subscribe(defaultYear => {
        this.getAttendanceCheckInOutByDate();
      })
    );
  }

  @ViewChild(MatSort) set sort(value: MatSort) {
    this._sort = value;
    this.angularMatData.sort = value;
  }

  get sort(): MatSort {
    return this._sort;
  }

  ngOnInit() {
    this.attendanceDate = new Date();
    this.previousDate = this.attendanceDate;
    this.getAttendanceCheckInOutByDate();
    this.schools = [];
    if (this.yearService.defaultYear.SchoolType != 'CO') {
      this.schools.push(this.yearService.schools.find(o => o.Id == this.yearService.defaultYear.SchoolID));
    }
    else {
      this.yearService.schools.forEach(element => {
        this.schools.push(element);
      });
    }
  }

  ngAfterViewInit() {
    this.datAttendanceDate.nativeElement.focus();
  }

  displayChange(type: string) {
    if (type == 'completed') {
      this.includeCompleted = !this.includeCompleted;
    }

    if (type == 'submitted') {
      this.includeSubmitted = !this.includeSubmitted;
    }

    this.filterData();
  }

  getAttendanceCheckInOutByDate() {
    this.attendanceAdminService.getAttendanceCheckInOutByDate(this.attendanceDate.toLocaleDateString()).pipe(take(1)).subscribe(result => {
      this.attendanceCheckInOut = result;
      this.attendanceCheckInOut.forEach(element => {
        element.Name = this.studentService.formatStudentName(element.StudentFirstName, element.StudentMiddleName, element.StudentLastName, '');
      });
      this.filterData();
    });
  }

  filterData() {
    this.angularMatData.data = [];
    if (this.includeCompleted == true && this.includeSubmitted == true) {
      this.angularMatData.data = this.attendanceCheckInOut;
    }
    else {
      let classes: AttendanceCheckInOut[] = [];
      if (this.includeCompleted) {
        classes = classes.concat(this.attendanceCheckInOut.filter(o => o.Status == 'Completed'));
      }

      if (this.includeSubmitted) {
        classes = classes.concat(this.attendanceCheckInOut.filter(o => o.Status == 'Submitted'));
      }

      this.angularMatData.data = classes;
    }

  }

  searchClick() {
    this.errors = [];
    if (this.attendanceDate == undefined || this.attendanceDate == null || this.attendanceDate.toLocaleDateString() == '') {
      this.errors.push({
        fieldName: 'Attendance Date',
        fieldRef: this.datAttendanceDate,
        errorMsg: ' Please enter the Attendance Date.'
      });
    }

    if (this.attendanceDate != undefined && this.attendanceDate != null && !moment(this.attendanceDate).isValid()) {
      this.errors.push({
        fieldName: 'Attendance Date',
        fieldRef: this.datAttendanceDate,
        errorMsg: ' Please enter the valid Attendance Date.'
      });
    }

    if (this.errors.length == 0) {
      this.previousDate = this.attendanceDate;
      this.getAttendanceCheckInOutByDate();
    }
  }

  keyDownFunction(event) {
    if (event.keyCode == 13) {
      this.searchClick();
    }
  }

  studentInfoClick(student) {
    // POST: show student related menus in right side
    const studentRecord = { Id: student.StudentId, FirstName: student.StudentFirstName, LastName: student.StudentLastName, MiddleName: student.StudentMiddleName, NickName: '' };
    const studentRecords = [];
    studentRecords.push(studentRecord);

    this.StudentInfoDialog = this.dialog.open(StudentInformationComponent, { panelClass: 'tyl-mat-dialog', disableClose: true, height: '100%', position: { top: '0px', right: '0px' } });
    this.StudentInfoDialog.componentInstance.student = studentRecord;
    this.StudentInfoDialog.componentInstance.students = studentRecords;
    this.StudentInfoDialog.componentInstance.initMenu();
  }

  addAttachmentClick(historyId: number) {
    // POST: opens a modal to add an attachment

    // Initializing attachment
    const attachment = new Attachment();
    attachment.Id = -1;
    attachment.DocumentId = 0;
    attachment.FileName = '';
    attachment.Description = '';
    attachment.UploadedDate = new Date();
    attachment.MyFileBase64String = '';
    attachment.FileType = '';
    attachment.Comment = '';
    attachment.ViewFileOnWebsite = true;

    // Opening modal
    const dialogBox = this.dialog.open<AddAttachmentDialogComponent>(AddAttachmentDialogComponent, {
      data: {
        attachment: attachment,
        newAttachment: true,
        requireDocumentType: true
      },
      disableClose: true
    });
    dialogBox.afterClosed().pipe(take(1)).subscribe(() => {
      if (dialogBox.componentInstance.saved) {
        const attachmentData: Attachment[] = [];
        attachmentData.push(attachment);
        this.saveAttachment(historyId, attachmentData);
      }
    });
  }

  saveAttachment(historyId: number, attachment: Attachment[]) {
    attachment.forEach(att => {
      att.AttachmentDescription = att.Description;
      att.DocumentBase64 = att.MyFileBase64String;
      att.MyFileBase64String = '';
    });
    this.attendanceAdminService.saveCheckInOutHistoryAttachment(historyId, attachment).pipe(take(1)).subscribe(result => {
      if (result == true) {
        this.getAttendanceCheckInOutByDate();
      }
    });
  }

  dateChange(date: Date) {
    if (date.toLocaleDateString() == this.todaysDate.toLocaleDateString()) {
      this.sameDate = true;
    }
    else {
      this.sameDate = false;
    }
  }

  deleteClick(recordId: number, type: string) {
    const deleteConfirmDialog = this.dialog.open(GeneralConfirmationComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true,
    });
    deleteConfirmDialog.componentInstance.headerLabel = 'Delete Check In/Out Record';
    deleteConfirmDialog.componentInstance.confirmMessage = 'Are you sure you want to delete this Check In/Check Out Record?';
    deleteConfirmDialog.componentInstance.okButtonLabel = 'Delete';
    deleteConfirmDialog.componentInstance.confirmEvent.pipe(take(1)).subscribe((deleteObject: boolean) => {
      if (deleteObject) {
        this.attendanceAdminService.deleteCheckInOutRecordById(recordId, type).pipe(take(1)).subscribe(result => {
          if (result == true) {
            this.getAttendanceCheckInOutByDate();
            const informationDialog = this.dialog.open(GeneralConfirmationComponent, {
              panelClass: 'tyl-mat-dialog',
              disableClose: true,
              maxWidth: '40vw',
              minWidth: '40vw'
            });
            informationDialog.componentInstance.headerLabel = 'Record Deleted';
            informationDialog.componentInstance.confirmMessage = 'The Check In (or Check Out) record has been deleted.  It is recommended you visit this students attendance for this date ' + this.attendanceDate.toString() + ' to correct/review their attendance.';
            informationDialog.componentInstance.disableConfirmation = true;
            informationDialog.componentInstance.informational = true;
          }
          else {
            this.sharedService.showBadSnackbar();
          }
        });
      }
    });
  }

  legendClick() {
    const dialogBox = this.dialog.open(AttendanceCheckInOutLegendComponent, {
      disableClose: true,
      maxWidth: '40vw',
      maxHeight: '65vh'
    });
  }

  howToClick() {
    const dialogBox = this.dialog.open(AttendanceCheckInOutHowToDialogComponent, {
      disableClose: true,
      minWidth: '40vw',
      maxWidth: '40vw',
      maxHeight: '75vh'
    });
  }

  editClick(attendanceCheckInOut: AttendanceCheckInOut) {
    this.attendanceAdminService.getCheckInOutHistoryAttachmentById(attendanceCheckInOut.HistoryId, 'History').pipe(take(1)).subscribe(attachment => {
      attendanceCheckInOut.Attachments = attachment;
      this.studentService.getStudent(attendanceCheckInOut.StudentId).pipe(take(1)).subscribe(student => {
        this.selectedStudent = student;

        const attendanceByStudentDialog = this.dialog.open(AttendanceByStudentComponent, {
          data: {
            calledAsDialog: true,
            selectedStudent: this.selectedStudent,
            attendanceDate: this.attendanceDate,
            attendanceCheckInOut: attendanceCheckInOut
          },
          disableClose: true,
          minWidth: '90vw',
          maxWidth: '90vw',
          minHeight: '90vh',
          maxHeight: '90vh'
        });

        attendanceByStudentDialog.afterClosed().pipe(take(1)).subscribe(result => {
          if (result != undefined) {
            // const attach = result.Attachments.filter(o => o.Id < 0 || o.Deleted == true);
            // if (attach.length > 0) {
            //   this.saveAttachment(result.CheckInOutHistoryId, result.Attachments);
            // }
            this.getAttendanceCheckInOutByDate();
          }
        });
      });
    });
  }

  processClick(attendanceCheckInOut: AttendanceCheckInOut) {
    this.attendanceAdminService.getCheckInOutHistoryAttachmentById(attendanceCheckInOut.SubmissionId, 'Submission').pipe(take(1)).subscribe(attachment => {
      attendanceCheckInOut.Attachments = attachment;
      this.studentService.getStudent(attendanceCheckInOut.StudentId).pipe(take(1)).subscribe(student => {
        this.selectedStudent = student;

        const attendanceByStudentDialog = this.dialog.open(AttendanceByStudentComponent, {
          data: {
            calledAsDialog: true,
            selectedStudent: this.selectedStudent,
            attendanceDate: this.attendanceDate,
            attendanceCheckInOut: attendanceCheckInOut,
            needToProcess: true
          },
          disableClose: true,
          minWidth: '90vw',
          maxWidth: '90vw',
          minHeight: '90vh',
          maxHeight: '90vh'
        });

        attendanceByStudentDialog.afterClosed().pipe(take(1)).subscribe(result => {
          if (result != undefined) {
            // this.saveAttachment(result.CheckInOutHistoryId, result.Attachments);
            this.attendanceAdminService.processSubmissionRecord(result.CheckInOutHistoryId, attendanceCheckInOut.SubmissionId).pipe(take(1)).subscribe(processed => {
              if (processed == true) {
                this.getAttendanceCheckInOutByDate();
              }
            });
          }
        });
      });
    });
  }

  viwAttachments(attendanceCheckInOut: AttendanceCheckInOut) {
    const id = attendanceCheckInOut.HistoryId != null && attendanceCheckInOut.HistoryId > 0 ? attendanceCheckInOut.HistoryId : attendanceCheckInOut.SubmissionId;
    const type = attendanceCheckInOut.HistoryId != null && attendanceCheckInOut.HistoryId > 0 ? 'History' : 'Submission';
    this.attendanceAdminService.getCheckInOutHistoryAttachmentById(id, type).pipe(take(1)).subscribe(attachment => {
      this.dialog.open(ViewAttachmentsComponent, {
        data: {
          attachments: attachment
        },
        disableClose: true,
        minWidth: '750px'
      });
    });
  }

  viewHistoryClick(studentId: number) {
    this.studentService.getStudent(studentId).pipe(take(1)).subscribe(student => {
      this.selectedStudent = student;

      const dialogBox = this.dialog.open(CheckInOutViewHistoryDialogComponent, {
        disableClose: true,
        minWidth: '80vw',
        maxWidth: '80vw',
        minHeight: '80vh',
        data: {
          selectedStudent: this.selectedStudent,
          schoolId: this.yearService.defaultYear.SchoolID
        }
      });

      dialogBox.afterClosed().pipe(take(1)).subscribe(result => {
        this.getAttendanceCheckInOutByDate();
      });
    });
  }

  checkInOutClick(type: string) {
    const selectedStudents: Student[] = [];

    const dialogRef = this.dialog.open(StudentSearchComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true,
      data: {
        performRoute: false,
        searchAndSelect: true,
        returnSelectedStudents: true,
        viewAllStudentsInThisSchoolYear: false,
        selectedStudents: selectedStudents,
        headerMessage: 'Step 1 of 3 - Select Students',
        schools: this.schools,
        hideSaveButton: true,
        showLargeHeaderMessage: true
      },
      width: '100%',
      height: '100%',
      maxWidth: '100vw',
      maxHeight: '100vh'
    });

    dialogRef.afterClosed().pipe(take(1)).subscribe((returnedStudents: Student[]) => {
      if (returnedStudents && returnedStudents instanceof Array) {
        const checkInOutDialogRef = this.dialog.open(CheckInOutModalDialogComponent, {
          disableClose: true,
          data: {
            selectedStudent: returnedStudents,
            type: type,
            attendanceDate: this.attendanceDate,
            schools: this.schools
          },
          minWidth: '40vw',
          maxWidth: '40vw',
          minHeight: '90vh',
          maxHeight: '90vh'
        });
      }
    });

    dialogRef.afterClosed().pipe(take(1)).subscribe(() => {
      this.getAttendanceCheckInOutByDate();
    });
  }

}
